interface Config {
  from: number;
  to: number;
}

export const changeRate = ({ from, to }: Config) => {
  if (from === 0) {
    return NaN;
  }
  return ((to - from) / from) * 100;
};
